import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenSingleImagePreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-single-image-preview-data.interface';
import { DesktopFrameComponent } from '../../../preview-common/desktop-frame/desktop-frame.component';

@Component({
    selector: 'app-gen-display-ad-desktop-14',
    imports: [CommonModule, DesktopFrameComponent],
    templateUrl: './display-ad-desktop-14.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/display/display-desktop-styles.scss',
        './display-ad-desktop-14.component.scss',
    ]
})
export class DisplayAdDesktop14PreviewComponent {
  @Input() data!: GenSingleImagePreviewData;

  /** Row count for the skeleton article text beside the ad rail. The bars carry
   *  no content, so the loop only needs something to iterate over. */
  readonly bodyBars = Array.from({ length: 5 });

  /** The publisher site nav, drawn as inert pills. Count only, as above. */
  readonly navItems = Array.from({ length: 4 });
}
